import React, { useEffect, useState, Fragment } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Grid } from "@mui/material";
import DatePicker from "react-datepicker";
import { deviceStatusPageSize, startDateLimit } from "./DeviceStatusConstants";
import DisplayDeviceStatusData from "./DisplayDeviceStatusData";
import { format } from "date-fns";
import "./DeviceStatus.css";

const DeviceStatus = ({
    deviceDetails,
    getDeviceStatusData,
    statusData,
    downloadDeviceStatusReport,
    setDialog,
    setDialogContents
}) => {
    const [deviceStatusData, setDeviceStatusData] = useState([]);
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showDeviceStatusDataList, setShowDeviceStatusDataList] = useState(false);
    const [isDataDownloading, setIsDataDownloading] = useState(false)
    const [pageIndex, setPageIndex] = useState(0);

    const getNextPage = () => {
        const newPg = pageIndex + 1
        setPageIndex(newPg);
        fetchDeviceStatusData(newPg)
    }

    const getPrevPage = () => {
        const newPg = pageIndex - 1;
        setPageIndex(newPg);
        fetchDeviceStatusData(newPg)
    }

    const fetchDeviceStatusData = (page = pageIndex, fromTs = formateDate(startDateFilter), toTs = formateDate(endDateFilter)) => {
        setIsLoading(true)
        getDeviceStatusData({
            deviceId: deviceDetails?.deviceId ?? "",
            fromTs,
            toTs,
            index: page,
            size: deviceStatusPageSize,
        }, () => {
            setIsLoading(false);
            setShowDeviceStatusDataList(true)
        })
    };
    const reset = () => {
        setStartDateFilter(new Date())
        setEndDateFilter(new Date())
        setPageIndex(0);
        const todaysDateTime = new Date(new Date()?.setHours(0, 0, 0, 0))
        fetchDeviceStatusData(0, formateDate(todaysDateTime), formateDate(new Date()));
    };
    const filter = () => {
        setPageIndex(0);
        fetchDeviceStatusData(0);
    };
    const handleStartDateChange = (date) => {
        setStartDateFilter(date)
        setEndDateFilter(null);
        setShowDeviceStatusDataList(false)
    }
    const handleEndDateChange = (date) => {
        setEndDateFilter(date);
        setShowDeviceStatusDataList(false)
    }
    function handleDownloadDeviceStatusData() {
        setIsDataDownloading(true)
        downloadDeviceStatusReport({
            fromTs: formateDate(startDateFilter),
            toTs: formateDate(endDateFilter),
            deviceId: deviceDetails.deviceId,
            printableStartDate: `${format(startDateFilter, "dd MMM yyyy")}-${format(endDateFilter, "dd MMM yyyy")}`
        }, () => {
            setIsDataDownloading(false)
        })
    }
    const formateDate = (dateFilter) => {
        if (dateFilter) {
            return dateFilter.getTime()
        }
    }

    useEffect(() => {
        setStartDateFilter(new Date());
        setEndDateFilter(new Date());
        setIsLoading(true);
        const todaysDateTime = new Date(new Date()?.setHours(0, 0, 0, 0))
        getDeviceStatusData({ deviceId: deviceDetails?.deviceId, fromTs: formateDate(todaysDateTime), toTs: Date?.now(), page: 0, size: deviceStatusPageSize },
            () => {
                setIsLoading(false);
                setShowDeviceStatusDataList(true)
            });
        setPageIndex(0);
    }, [deviceDetails?.deviceId, getDeviceStatusData])

    useEffect(() => {
        setDeviceStatusData(statusData)
    }, [statusData])

    return (
        <Fragment>
            <Box sx={{ width: "100%", minWidth: 0 }}>
                <Box className="content-block bottom-shadow">
                    <Box className="py-15" sx={{ px: 0 }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                                <Box component="span" sx={{ mr: 1 }}>From:</Box>
                                <DatePicker
                                    selected={startDateFilter}
                                    minDate={(() => {
                                        const d = new Date();
                                        return new Date(d.setDate(d.getDate() - startDateLimit));
                                    })()}
                                    maxDate={new Date()}
                                    onChange={handleStartDateChange}
                                    placeholderText="Start Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="add-input calendar input_phone"
                                    style={{ flex: 1, minWidth: 0 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                                <Box component="span" sx={{ mr: 1 }}>To:</Box>
                                <DatePicker
                                    selected={endDateFilter}
                                    minDate={startDateFilter}
                                    maxDate={new Date()}
                                    onChange={handleEndDateChange}
                                    placeholderText="End Date"
                                    dateFormat="MM/dd/yyyy"
                                    className="add-input calendar input_phone"
                                    style={{ flex: 1, minWidth: 0 }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
                                <button
                                    type="button"
                                    className="btn btn-style-2 orange-bg"
                                    onClick={filter}
                                    disabled={startDateFilter === null || endDateFilter === null}
                                    style={{ marginRight: 8 }}
                                >
                                    Filter
                                </button>
                                <button type="button" className="btn btn-style-2 dark-text gray-bg" onClick={reset} style={{ marginRight: 8 }}>
                                    Reset
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-style-2 orange-bg cursor-Hand"
                                    onClick={handleDownloadDeviceStatusData}
                                    disabled={isDataDownloading || startDateFilter === null || endDateFilter === null}
                                >
                                    {isDataDownloading ? (
                                        <CircularProgress size="2em" style={{ color: "#AFB42B", marginTop: "5px" }} />
                                    ) : "Download"}
                                </button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                {isLoading && (
                    <Box sx={{ display: "grid", placeItems: "center", height: "20vh" }}>
                        <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
                    </Box>
                )}
                {!isLoading && showDeviceStatusDataList && (
                    <Box className="content-block bottom-shadow py-15 mb-30" sx={{ mt: 2 }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Box className="table-wrapper mb-20" sx={{ overflowX: "auto", overflowY: "auto", maxHeight: 400 }}>
                                    <DisplayDeviceStatusData
                                        setDialog={setDialog}
                                        setDialogContents={setDialogContents}
                                        deviceCategory={deviceDetails.category}
                                        deviceStatusData={deviceStatusData}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mt: 1 }}>
                                    <button
                                        type="button"
                                        className="btn btn-style-2 orange-bg"
                                        onClick={() => getPrevPage()}
                                        disabled={pageIndex === 0}
                                    >
                                        Previous
                                    </button>
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {`Page : ${pageIndex + 1}`}
                                        <button
                                            type="button"
                                            className="btn btn-style-2 orange-bg"
                                            style={{ marginLeft: 8 }}
                                            onClick={() => getNextPage()}
                                            disabled={deviceStatusData?.length < deviceStatusPageSize}
                                        >
                                            Next
                                        </button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Box>
        </Fragment>
    );
};

export default DeviceStatus;